import * as React from 'react';
import { FormControl } from "@common/components/form-control";
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field, FieldError } from '../field';
import cx from 'classnames';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';
import { Button } from '@common/components/Button';

import './text-edit.styles.scss';

export type TextEditProps = IInputComponent<string> & {
  inputWidth?: number | string;
  errors?: Array<FieldError>;
  placeholder?: string;
};

export const TextEdit: React.FC<TextEditProps> = (props) => {
  const { inputWidth, errors, className, disabled, onChange, value, metadata, description, required, margin, placeholder } = props;
  const [localValue, setLocalValue] = React.useState<string>('');
  const [isEditing, setIsEditing] = React.useState(false);

  React.useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value || '');
    }
  }, [value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
  }, []);

  const handleBlur = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  }, [onChange]);

  const turnOnEditing = React.useCallback(() => {
    setIsEditing(true);
  }, []);

  return (
    <Field 
      inputWidth={inputWidth}
      label={<>{value}{!isEditing && <Button className="FhqDesignToolTextEdit__edit-btn" variant="text" onClick={turnOnEditing}><i className="fa fa-pencil" /></Button>}</>} 
      disabled={disabled}
      labelWidth="auto"
      className={cx('FhqDesignToolTextEdit', className)}
      description={description}
      required={required}
      margin={margin}
      errors={errors}
      classes={{
        label: 'FhqDesignToolTextEdit__label',
        labelInputWrapper: 'FhqDesignToolTextEdit__input-label-wrapper'
      }}
    >
      {isEditing && (
        <FormControl 
          {...getTestAttributes(MODULE_NAME, metadata.description, 'text-edit')}
          placeholder={placeholder}
          value={localValue} 
          onChange={handleChange} 
          onBlur={handleBlur} 
        />
      )}
    </Field>
  );
};